import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { ToastService } from 'src/app/core/toast/toast.service';
import { AppInfoRequest } from 'src/app/model/global-interface';
import { BaseResponse } from 'src/app/model/response/base-response';
import { GlobalService } from 'src/app/services/global.service';
import { LocalStorageService } from 'src/app/services/local-storage.service';

@Component({
  selector: 'app-settings-cache',
  templateUrl: './settings-cache.component.html',
  styleUrl: './settings-cache.component.scss'
})
export class SettingsCacheComponent implements OnInit, OnDestroy {

  private theEnd$ = new Subject<void>();

  constructor(private globalService: GlobalService, private toastService: ToastService, private localStorageS: LocalStorageService) {
    
  }

  ngOnInit(): void {
    
  }

  ngOnDestroy(): void {
    this.theEnd$.unsubscribe();
  }

  clean() {
    let req: AppInfoRequest = {
      cache: true,
      cookies: false,
      storage: false,
    };

    this.globalService.cleanAppData(req).pipe(takeUntil(this.theEnd$)).subscribe({
      next: (res: BaseResponse) => {
        this.toastService.GenerateToast({
          title: 'Cache pulita',
          severity: 'e-toast-success',
        });
        setTimeout(() => {
          this.localStorageS.addValue("refresh","true");
          location.reload();
        }, 10);
      },
      error: (res: BaseResponse) => {
        this.toastService.GenerateToast({
          title: 'Errore nella pulizia',
          severity: 'e-toast-danger',
        });
      }
    });
  }

  cleanAll() {
    let req: AppInfoRequest = {
      cache: true,
      cookies: true,
      storage: true,
    };

    this.globalService.cleanAppData(req).pipe(takeUntil(this.theEnd$)).subscribe({
      next: (res: BaseResponse) => {
        this.toastService.GenerateToast({
          title: 'Cache pulita',
          severity: 'e-toast-success',
        });
        setTimeout(() => {
          this.localStorageS.addValue("refresh","true");
          location.reload();
        }, 10);
      },
      error: (res: BaseResponse) => {
        this.toastService.GenerateToast({
          title: 'Errore nella pulizia',
          severity: 'e-toast-danger',
        });
      }
    });
  }

}
